module.exports = __webpack_public_path__ + "static/fonts/Fredoka-Bold.0ca2ea9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/fredoka/Fredoka-Bold.ttf
// module id = 567
// module chunks = 9